if (!customElements.get('age-verifier')) {
  customElements.define(
    'age-verifier',
    class AgeVerifier extends ModalElement {
      constructor() {
        super();
    
        this.init();
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return 1;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:age-verifier';
      }
    
      init() {
        const value = this.getCookie(this.cookieName);
        if (this.testMode || !value) {
          this.load(this.delay);
        }
        else if (value === 'true') {
          // Written before 12 Oct 2026 without SameSite, which DevTools reports on every page (Shopify's
          // pixel sandbox reads it cross-site). Rewrite it once with the attributes below ('1' marks it).
          this.setCookie(this.cookieName, this.expiry);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=1; max-age=${(expiry * 24 * 60 * 60)}; path=/; SameSite=Lax; Secure`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0; path=/; SameSite=Lax; Secure`;
      }
    }
  );
}
